<template>
  <div class="form-item">
    <span v-if="title" class="form-item__title">{{ title }}</span>
    <div v-click-outside="close" class="form-item__block">
      <div v-if="result && result.id" class="form-item__input users__list-card">
        <Avatar :img="result.avatar || result.icon" circle="circle" size="xxs"></Avatar>
        <div class="users__list-card__info">
          <p class="users__list-card__text">{{ result.name }} {{ result.lastname }}</p>
          <p class="users__list-card__email">{{ result.email }}</p>
          <Icon
            class="form-item__icon form-item__delete"
            icon="input-delete"
            @click="clearInfo"
          ></Icon>
        </div>
      </div>
      <div v-else class="form-item__select select" :class="{ '-error__class-': errorSearch }">
        <Input
          v-model="search"
          class="width-100"
          :placeholder="placeholder"
          :error="errorSearch"
          :show-icon="false"
        >
          <span v-if="errorSearch" class="form-item__error" style="margin-top: 15px"
            >* Пользователь не найден
          </span>
        </Input>
      </div>
      <SlideUpDown
        v-if="!disabled"
        class="select__slider"
        :duration="slideDuration"
        :active="isOpen"
      >
        <div class="select__field -no-padding-">
          <div
            v-for="(selectItem, idx) in getData"
            :key="idx"
            class="select__item users__list-card"
            :style="addIcon(selectItem)"
            @click="setOption(selectItem)"
          >
            <Avatar :img="selectItem.avatar || selectItem.icon" circle="circle" size="xxs"></Avatar>
            <div class="users__list-card__info">
              <p class="users__list-card__text">{{ selectItem.name }} {{ selectItem.lastname }}</p>
              <p class="users__list-card__email">{{ selectItem.email }}</p>
            </div>
          </div>
        </div>
      </SlideUpDown>
      <Icon
        v-if="!result"
        class="select__icon form-item__icon"
        :icon="!icon ? 'arrow-down' : icon"
        :class="{ '-opened-': isOpen }"
        @click="toggleOpen"
      ></Icon>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';
import { mapState, mapActions } from 'vuex';

export default {
  directives: { clickOutside: vClickOutside.directive },
  components: { SlideUpDown },
  props: {
    value: {},
    disabled: {
      type: Boolean,
      default: false
    },
    title: {},
    error: {},
    icon: {},
    placeholder: {},
    message: {},
    user: {},
    trackerId: {},
    managerId: {}
  },
  data: () => ({
    isOpen: false,
    result: '',
    slideDuration: 200,
    search: '',
    getData: '',
    errorSearch: false
  }),
  computed: {
    ...mapState('users', {
      data: s => s.data.mentors
    })
  },
  watch: {
    value() {
      this.result = this.value;
    },
    getData(val) {
      if (val && val.length === 0 && this.search && this.search.length > 0) {
        this.errorSearch = true;
      } else {
        this.errorSearch = false;
      }
    },
    data(val) {
      if (val && this.search && this.search.length && val.length) {
        this.getData = _.cloneDeep(val).filter(
          el => el.id != this.user && !(this.trackerId == el.id || this.managerId == el.id)
        );
        this.isOpen = true;
      } else {
        this.getData = [];
        this.isOpen = false;
      }
    },
    search(val) {
      if (val.length > 0) {
        this.getUsersMentors({ name: val });
      } else {
        this.close();
      }
    }
  },
  mounted() {
    if (this.value) {
      this.result = this.value;
    }

    if (this.data) {
      this.getData = _.cloneDeep(this.data);
    }
  },
  destroyed() {
    this.clearData();
  },
  methods: {
    ...mapActions('users', ['getUsersMentors']),
    close() {
      this.isOpen = false;
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    setOption(item) {
      this.close();
      this.$emit('input', item);
      this.clearData();
    },
    addIcon({ icon }) {
      if (icon) {
        return {
          backgroundImage: `url(${icon})`,
          backgroundColor: 'grey',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        };
      } else {
        return {};
      }
    },
    clearData() {
      this.search = '';
      this.$store.dispatch('users/setData', { path: 'data', value: [] });
    },
    clearInfo() {
      this.result = '';
      this.$emit('input', '');
    }
  }
};
</script>
